import { render, staticRenderFns } from "./damage-claims-form.vue?vue&type=template&id=975b6e92&"
import script from "./damage-claims-form.vue?vue&type=script&lang=js&"
export * from "./damage-claims-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports